import { Dom7 as $ } from "framework7/bundle";

// Ablauf innerhalb einer Therapie-Karte: Bloecke nacheinander einblenden,
// CTA/Endscreen/Timer beruecksichtigen, Kartenhoehe nachziehen.

const setInlineProgress = (value) => {
    $('#therapy_progressbar').attr('data-progress', value);
}

const stepInsideCard = (contentPageId) => {
    let activated = 0;
    let isChatInvolved = 0;
    let hiddenElements = 0;
    let needScroll = false;
    let skippOthers = false;
    $('#contentId-' + contentPageId).children('.block').each(function() {
        if ($(this).hasClass('block-next-button')) {return false;}
        if ($(this).css('display') != 'none' && $(this).hasClass('block-chat-dialog')) {
            //Step into Chat-Dialog
            $(this).children('.chat-message-wrap').each(function() {
                if ($(this).css('display') == 'none' && activated == 0) {
                    $(this).show();
                    activated = 1;
                    isChatInvolved = 1;
                    needScroll = true;
                }
            });
        }

        if (isChatInvolved == 1 && activated == 1) return false;

        if ($(this).css('display') == 'none' && !skippOthers) {
            hiddenElements++;
            if (activated == 0) {
                //Activate Element
                $(this).show();
                activated = 1;
                needScroll = true;
            } else {
                if ($(this).data('appearance') == "0") {
                    $(this).show();
                    needScroll = true;
                } else {
                    skippOthers = true;
                    return false;
                }
            }
        }
    });

    //Check if a page-break is needed
    if (hiddenElements == 0 && activated == 0) {
        return true;
    }

    //Always show "next"-Button
    $('#contentId-' + contentPageId).children('.block.block-next-button').show();

    checkCTAElement(contentPageId);
    checkEndScreen(contentPageId);
    checkCardHeight(contentPageId);
    return false;
}

const checkCTAElement = (contentPageId) => {
    let isCTAActive = false;
    if ($('#contentId-' + contentPageId).children('.block-cta').length > 0) {
        //CTA is present, check if active
        if ($('#contentId-' + contentPageId).children('.block-cta').css('display') != 'none') { isCTAActive = true; }
    }

    if (isCTAActive) {
        $('#contentId-' + contentPageId).children('.block.block-next-button').hide();
    }
}

const checkEndScreen = (contentPageId) => {

    if ($('#contentId-' + contentPageId).children('.block-endscreen').length > 0) {
        //End screen reached
        $('.navbar').addClass('navbar-hidden');
        $('.navbar').hide();
        $('#contentId-' + contentPageId).children('.block.block-next-button').hide();
    }


}

const checkCardHeight = (contentPageId) => {
    $('#contentId-' + contentPageId).removeClass('stretched');

    const tWinHeight = $('#contentId-' + contentPageId).height();
    let tHeight = 0;
    let needStretch = 0;

    $('#contentId-' + contentPageId).children().each(function() {
        if ($(this).hasClass('block-next-button')) {
            tHeight = tHeight + $(this).outerHeight(false);
        } else {
            tHeight = tHeight + $(this).outerHeight(true);
        }
        if ($(this).hasClass('block-video')) needStretch = 1;
    });

    //tHeight = tHeight + $('.navbar').height();
    //console.log('window: ' + tWinHeight + ', content: ' + tHeight);
    //console.log('has Scroll: ' + $('#contentId-' + contentPageId).hasClass('scrollme'));
    if ((tWinHeight - tHeight) > 0 || needStretch == 1) {
        $('#contentId-' + contentPageId).css('height', tWinHeight - tHeight + 'px');
        $('#contentId-' + contentPageId).addClass('stretched');
    } else {
        //Check, if scroll is needed
        if ($('#contentId-' + contentPageId).hasClass('scrollme')) {
            $('#contentId-' + contentPageId).removeClass('stretched');
            $('.page-content').scrollTop(tHeight, 800);

            $('.navbar.navbar-current').addClass('navbar-hidden');
        }
    }

    $('#contentId-' + contentPageId).addClass('scrollme');
}

function checkActivity(type, activityId, arrActivities) {
    return 'locked';
}

//Timer
let TIME_LIMIT = 0;
let TimerContentPageId = '';
let timePassed = 0;
let timeLeft = TIME_LIMIT;
let timerInterval = null;
const FULL_DASH_ARRAY = 282.74;

const checkTimerElement = (contentPageId) => {
    let isTimerActive = false;
    if ($('#contentId-' + contentPageId).children('.block-timer').length > 0) {
        //Timer is present, check if active
        if ($('#contentId-' + contentPageId).children('.block-timer').css('display') != 'none') { isTimerActive = true; }
    }

    if (isTimerActive) {
        TIME_LIMIT = $('#base-timer-label').data('time');
        TimerContentPageId = contentPageId;
        startTimer();
        $('#contentId-' + contentPageId).children('.block.block-next-button').hide();
    }
}

const formatTimeLeft = (time) => {
    // The largest round integer less than or equal to the result of time divided being by 60.
    const minutes = Math.floor(time / 60);

    // Seconds are the remainder of the time divided by 60 (modulus operator)
    let seconds = time % 60;

    // If the value of seconds is less than 10, then display seconds with a leading zero
    if (seconds < 10) {
        seconds = `0${seconds}`;
    }

    // The output in MM:SS format
    return `${minutes}:${seconds}`;
}

function calculateTimeFraction() {
    return timeLeft / TIME_LIMIT;
}

// Update the dasharray value as time passes, starting with 283
function setCircleDasharray() {
    const circleDasharray = `${(
        calculateTimeFraction() * FULL_DASH_ARRAY
    ).toFixed(0)} 282.74`;
    document
        .getElementById("base-timer-path-remaining")
        .setAttribute("stroke-dasharray", circleDasharray);
}

function onTimesUp() {
    clearInterval(timerInterval);
    $('#contentId-' + TimerContentPageId).children('.block.block-next-button').show();
}

function startTimer() {
    if (timerInterval === null) {
        timerInterval = setInterval(() => {

            // The amount of time passed increments by one
            timePassed = timePassed += 1;
            timeLeft = TIME_LIMIT - timePassed;

            // The time left label is updated
            document.getElementById("base-timer-label").innerHTML = formatTimeLeft(timeLeft);
            setCircleDasharray();
            if (timeLeft < 1) {
                onTimesUp();
            }
        }, 1000);
    }
}

export { setInlineProgress, stepInsideCard, checkCTAElement, checkEndScreen, checkCardHeight, checkActivity, checkTimerElement };
